import { Component, Input } from '@angular/core';

@Component({
  selector: 'ling-page',
  templateUrl: './page.component.html',
  styleUrls: ['./page.component.scss'],
})
export class PageComponent {
  @Input() disableMinHeight = false;
  @Input() overflow = 'hidden';
  @Input() loading = false;
  @Input() loadingFailed = '';
}
